import { Box, Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { attrGrpTableStrColumnsObj } from "components/PimDashboard/data";
import { useEffect, useState } from "react";
import { studioAttrGrpAttrAssocObj } from "../../StudioAttributes/data";
import { DataGrid } from "@mui/x-data-grid";
import { StudioDashboardState } from "context/StudioDashboardContext";
import { studioAttrGroupLinkedTables } from "../../StudioAttributeGroups/data";
import { arrType, datatypes, inputTypes, selectOptionsKeyName } from "data/globalData";
import axios from "axios";
import SearchInputFieldWithDebounce from "components/PimDashboard/CommonComponents/SearchInputFieldWithDebounce/SearchInputFieldWithDebounce";
import { GlobalState } from "context/GlobalContext";

export const TableImgComponent = ({ data, column }) => {
	return (
		<Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
			<Box
				component="label"
				width="45px"
				height="55px"
				border={`1px solid ${grey[200]}`}
				display="flex"
				alignItems="center"
				justifyContent="center"
				overflow="hidden"
				position="relative">
				<img src={data?.[column]} style={{ width: "100%", position: "absolute" }} />
			</Box>
		</Box>
	);
};

export const shootFilterCol = {
	name: "Shoot",
	key: "shoot",
	input_type: inputTypes.SELECT.key,
	constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 1,
	group: "",
	placeholder: "",
	default_value: "",
	[selectOptionsKeyName]: {
		type: arrType,
		list: [],
		getOptionLabel: (opt) => ({ name: opt.shoot_id, key: opt.shoot_id }),
	},
};
const ShootSelection = ({ selectedShoots, setSelectedShoots, costingDetails, disabled, hideInput = false, height = 300 }) => {
	const { attrGroupsWithAttr, allAttributes } = StudioDashboardState();
	const { snackBar, setSnackBarOpen, setSnackBar } = GlobalState();
	const [modalTableColumns, setModalTableColumns] = useState();
	useEffect(() => {
		let attrs = [];
		Object.keys(attrGroupsWithAttr).forEach((grpId) => {
			if (attrGroupsWithAttr[grpId][attrGrpTableStrColumnsObj.linked_table.key] === studioAttrGroupLinkedTables.shoot.key)
				attrs = attrGroupsWithAttr[grpId][studioAttrGrpAttrAssocObj];
		});
		setModalTableColumns(attrs?.length ? attrs : []);
	}, [attrGroupsWithAttr]);

	const fetchRowsBasedOnSearch = async (offset = 0, limit = 20, searchTerm = "") => {
		const query = {
			limit,
			offset,
		};
		if (searchTerm) query["search"] = searchTerm;
		// construct your request logic
		const res = await axios.get(`/api/studio/shoots_by_search`, {
			params: query,
			query: {},
		});

		return res;
	};

	const handleSelect = (newData) => {
		let obj = typeof newData === "function" ? newData({}) : newData;
		if (obj?.[shootFilterCol.key]?.shoot_id) {
			if (selectedShoots?.find((row) => row?.shoot_id === obj?.[shootFilterCol.key]?.shoot_id)) {
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Shoot already selected",
					severity: "warning",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
				return;
			}
			setSelectedShoots((prev) => [
				...prev.filter((row) => row.shoot_id !== obj?.[shootFilterCol.key]?.shoot_id),
				obj[shootFilterCol.key],
			]);
		}
	};
	return (
		<Box display="flex" flexWrap="wrap" width="100%">
			<Stack height={height} width="100%" spacing={1}>
				<Stack sx={{ display: hideInput ? "none" : "block", maxWidth: 400 }} spacing={1}>
					<Typography variant="h6" width="100%">
						Add Shoots
					</Typography>
					<SearchInputFieldWithDebounce
						disableLabel
						column={shootFilterCol}
						data={{ [shootFilterCol.key]: selectedShoots }}
						setData={handleSelect}
						fetchData={fetchRowsBasedOnSearch}
						selectOptKeyName={selectOptionsKeyName}
						storeValueAs="object"
						disabled={disabled}
					/>
				</Stack>
				{modalTableColumns?.length >= 0 && (
					<DataGrid
						rows={selectedShoots ? selectedShoots : []}
						columns={[
							{
								headerName: "Image",
								field: "img",
								minWidth: 120,
								headerAlign: "center",
								flex: 1,
								renderCell: ({ row }) => {
									return <TableImgComponent data={row} column="url" />;
								},
							},
							...modalTableColumns?.map((colorCol) => {
								return {
									field: colorCol?.key,
									headerName: colorCol?.name?.toUpperCase(),
									minWidth: 130,
									headerAlign: "center",
									align: "center",
									flex: 1,
								};
							}),
							// deleteTableColumn(handleColorDelete),
						]}
						getRowId={(row) => row?.shoot_id}
						sx={{
							// minHeight: "90%",
							// maxHeight: "90%",
							// width: "95%",
							"& .MuiDataGrid-row": {
								borderBottom: "1px solid lightgray",
								cursor: "pointer",
							},
							"& .MuiDataGrid-columnHeader": {
								cursor: "pointer",
								// background: grey[300],
								borderRight: "1px solid lightgray",
							},
						}}
						columnHeaderHeight={35}
						rowHeight={60}
						disableRowSelectionOnClick
						pageSizeOptions={[5, 10]}
						hideFooter
						pagination={false}
						disableAutosize
					/>
				)}
			</Stack>
		</Box>
	);
};

export default ShootSelection;
